import React from "react";

const Availability = () => {
  return (
    <>
      <div>Availability</div>
    </>
  );
};

export default Availability;
